import type { TopologyGraphPreset } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';

export const selectPresets = (state: GraphState): TopologyGraphPreset[] =>
  state.layoutSettings.presets;
